/* eslint-disable max-len */
import './App.scss';
import FttsLandingPage from './Pages/FttsLandingPage';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { ThemeProvider, createTheme } from '@mui/material';
import { MainLandingPage } from './Pages/LandingMain/mainLandingPage';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { NewLoginScreen } from './Pages/logIn/NewLoginScreen';
import { MainLoginScreen } from './Pages/logIn/main_Login_Screen.component';
import { LandingPageUserManagement } from './Pages/UserManagement/landing_Page_user_management.component';
import ProtectedRoute from './Pages/logIn/protected_Routes_component';
import { BackdropProvider } from './common/components/backDrop_context.component';
import { TenantMainPage } from './Pages/TenantManagement/tenant_main.component';
import PocMainComponent from './Pages/Poc/poc_main.component';
import RouteAnalysis from './Pages/Poc/routeAnalysis/poc_route_ananlysis.component';
import RouteAnalysisTable from './Pages/Poc/routeAnalysis/poc_route_details_table';
import LeasingRouteAnalysisTable from './Pages/Leasing Deployment/routeAnalysis/poc_route_details_table';
import LeasingRouteAnalysis from './Pages/Leasing Deployment/routeAnalysis/poc_route_ananlysis.component';
import PocLeasingDeploymentMainComponent from './Pages/Leasing Deployment/poc_Leasing_deployment_main.component';
import { Provider } from 'jotai';
import { KmzMainComponent } from './Pages/Kmz/kmz_main.component';
import { InventoryMainComponent } from './Pages/Inventory/inventory_main.component';
import { LeasedFiberMainComponent } from './Pages/LeasedFiberPair/leasedFiber_main.component';
import { RAN_DB_Main_PAGE } from './common/constants/constants';
import { RanDBMain } from './Pages/RanDB/ran_db_main.component';
import { FiberSitePlanningMain } from './Pages/fiberSitePlanning';
import { NetworkLayerVisulizationMain } from './Pages/NetworkLayerVisulization/network_layer_visulization_main_component';
import RingPlanningMain from './Pages/ringPlanning/ring_planning_main.component';
import { JazzSupportPage } from './Pages/JazzSupport/JazzSupportPage';
import { LoginLockoutMainPage } from './Pages/LoginLockoutManagement/login_lockout_main.component';
import FiberPopListMain from './Pages/FiberPopList/fiber_pop_list_main.component';
import { PurchaseOrderManagement } from './Pages/PurchaseOrderManagement/purchase_order_management.component';
import { POWorkflowManagement } from './Pages/POWorkflowManagement/po_workflow_management.component';
import { InvoicePage } from './Pages/POWorkflowManagement/InvoicePage';
import POInvoiceDetails from './Pages/POWorkflowManagement/POInvoiceDetails';
import { ApprovalPersonsInvoiceManagement } from './Pages/ApprovalPersonsInvoiceManagement/approval_persons_invoice_management.component';
import { ApprovalPersonsSystemInvoiceManagement } from './Pages/ApprovalPersonsSystemInvoiceManagement/approval_persons_invoice_management.component';
import { VendorInvoiceManagement } from './Pages/VendorInvoiceManagement/vendor_invoice_management.component';
import VendorInvoiceForm from './Pages/VendorInvoiceManagement/vendor_invoice_form.component';
import VendorInvoiceDetails from './Pages/VendorInvoiceManagement/vendor_invoice_details.component';
import InvoiceApproveRejectForm from './Pages/ApprovalPersonsInvoiceManagement/invoice_approve_reject_form.component';
import SystemInvoiceApproveRejectForm from './Pages/ApprovalPersonsSystemInvoiceManagement/invoice_approve_reject_form.component';
import { SystemVendorInvoiceManagement } from './Pages/SystemVendorInvoiceManagement/system_vendor_invoice_management.component';
import SystemVendorInvoiceForm from './Pages/SystemVendorInvoiceManagement/system_vendor_invoice_form.component';
import SystemVendorInvoiceDetails from './Pages/SystemVendorInvoiceManagement/system_vendor_invoice_details.component';
import SystemPurchaseOrderManagement from './Pages/SystemAdminInvoiceManagement/system_purchase_order_management.component';
import SystemPOWorkflowManagement from './Pages/SystemAdminInvoiceManagement/system_po_workflow_management.component';
import { SystemInvoicePage } from './Pages/SystemAdminInvoiceManagement/system_invoice_page.component';
import SystemPOInvoiceDetails from './Pages/SystemAdminInvoiceManagement/system_po_invoice_details.component';
import { InvoiceApproverAssignmentsMain } from './Pages/InvoiceApproverAssignments/invoice_approver_assignments_main.component';
import { SystemInvoiceApproverAssignmentsMain } from './Pages/SystemInvoiceApproverAssignments/system_invoice_approver_assignments_main.component';
import { PoWorkflowFilterScope } from './Pages/POWorkflowManagement/po_workflow_filter_scope.component';
import { InvoiceAttachmentManagement } from './Pages/InvoiceAttachmentManagement/invoice_attachment_management.component';

const theme = createTheme({
  typography: {
    // fontFamily: 'Poppins',
  },
  palette: {
    primary: {
      main: '#BD1D23',
    },
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
              borderColor: '#BD1D23',
            },
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#BD1D23',
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#BD1D23',
          },
        },
      },
    },
  },
});
function App() {
  const environment = process.env.REACT_APP_ENVIRONMENT;

  return (
    <Provider>
      <BackdropProvider>
        {/* <MapWithDirections /> */}
        <Router>
          <PoWorkflowFilterScope />
          <div className="App">
            <ThemeProvider theme={theme}>
              <Routes>
                <Route path="/fibers" element={<ProtectedRoute element={FttsLandingPage} />} />
                <Route
                  path="/userManagement"
                  element={
                    <ProtectedRoute
                      element={LandingPageUserManagement}
                      requiredPermission="USER_MANAGEMENT"
                    />
                  }
                />
                <Route
                  path="/tenantManagement"
                  element={
                    <ProtectedRoute element={TenantMainPage} requiredPermission="USER_MANAGEMENT" />
                  }
                />
                {/* <Route
                  path="/kmz"
                  element={<ProtectedRoute element={KmzMainComponent} requiredPermission="KMZ" />}
                /> */}
                <Route
                  path="/rov"
                  element={<ProtectedRoute element={MainLandingPage} requiredPermission="ROV" />}
                />
                <Route
                  path={RAN_DB_Main_PAGE}
                  element={<ProtectedRoute element={RanDBMain} requiredPermission="RAN_DB" />}
                />
                <Route
                  path="/oko/fiberSite"
                  element={
                    <ProtectedRoute
                      element={FiberSitePlanningMain}
                      requiredPermission="FIBER_SITE_PLANNING"
                    />
                  }
                />
                {/* <Route path="/rov" element={<MainLandingPage />} /> */}

                <Route
                  path="/"
                  element={environment === 'production' ? <MainLoginScreen /> : <NewLoginScreen />}
                />
                <Route
                  path="/kmzMap"
                  element={
                    <ProtectedRoute
                      element={KmzMainComponent}
                      requiredPermission="PARTNER_NETWORK"
                    />
                  }
                />
                <Route
                  path="/networkPlanning/kmzPlanning"
                  element={<ProtectedRoute element={KmzMainComponent} requiredPermission="KMZ" />}
                />
                <Route path="/inventory" element={<InventoryMainComponent />} />
                <Route path="/leasedFiber" element={<LeasedFiberMainComponent />} />
                <Route path="/networkLayer" element={<NetworkLayerVisulizationMain />} />
                <Route path="/fiberSitePlanning" element={<FiberSitePlanningMain />} />
                <Route
                  path="/networkPlanning/ringPlanning"
                  element={
                    <ProtectedRoute element={RingPlanningMain} requiredPermission="Ring Planning" />
                  }
                />
                <Route
                  path="/networkPlanning/fiberPopList"
                  element={
                    <ProtectedRoute
                      element={FiberPopListMain}
                      requiredPermission="Fiber Pop List"
                    />
                  }
                />
                <Route
                  path="/routePlanning"
                  element={<ProtectedRoute element={PocMainComponent} />}
                />
                <Route path="/leasingDeployment" element={<PocLeasingDeploymentMainComponent />} />
                <Route path="/routeAnalysis" element={<RouteAnalysis />} />
                <Route
                  path="/routeAnalysisDetails/:startLocation/:endLocation"
                  element={<RouteAnalysisTable />}
                />
                <Route path="/leasingRouteAnalysis" element={<LeasingRouteAnalysis />} />
                <Route
                  path="/leasingRouteAnalysisDetails/:startLocation"
                  element={<LeasingRouteAnalysisTable />}
                />
                <Route path="/jazzSupport" element={<ProtectedRoute element={JazzSupportPage} />} />
                <Route
                  path="/loginLockoutManagement"
                  element={<ProtectedRoute element={LoginLockoutMainPage} />}
                />
                <Route
                  path="/purchaseOrderManagement"
                  element={
                    <ProtectedRoute
                      element={PurchaseOrderManagement}
                      requiredPermission="Admin Invoice Management"
                    />
                  }
                />
                <Route
                  path="/systemPurchaseOrderManagement"
                  element={
                    <ProtectedRoute
                      element={SystemPurchaseOrderManagement}
                      requiredPermission="System Invoice Management"
                    />
                  }
                />
                <Route
                  path="/poWorkflowManagement"
                  element={
                    <ProtectedRoute
                      element={POWorkflowManagement}
                      requiredPermission="Admin Invoice Management"
                    />
                  }
                />
                <Route
                  path="/invoiceAttachmentManagement"
                  element={
                    <ProtectedRoute
                      element={InvoiceAttachmentManagement}
                      requiredPermission="Invoice Attachment Management"
                    />
                  }
                />
                <Route
                  path="/systemPoWorkflowManagement"
                  element={
                    <ProtectedRoute
                      element={SystemPOWorkflowManagement}
                      requiredPermission="System Invoice Management"
                    />
                  }
                />
                <Route
                  path="/systemPoWorkflowManagement/invoices"
                  element={
                    <ProtectedRoute
                      element={SystemInvoicePage}
                      requiredPermission="System Invoice Management"
                    />
                  }
                />
                <Route
                  path="/systemPoWorkflowManagement/invoices/details"
                  element={
                    <ProtectedRoute
                      element={SystemPOInvoiceDetails}
                      requiredPermission="System Invoice Management"
                    />
                  }
                />
                <Route
                  path="/poWorkflowManagement/invoices"
                  element={
                    <ProtectedRoute
                      element={InvoicePage}
                      requiredPermission="Admin Invoice Management"
                    />
                  }
                />
                <Route
                  path="/poWorkflowManagement/invoices/details"
                  element={
                    <ProtectedRoute
                      element={POInvoiceDetails}
                      requiredPermission="Admin Invoice Management"
                    />
                  }
                />
                <Route
                  path="/invoiceApproverAssignments"
                  element={<ProtectedRoute element={InvoiceApproverAssignmentsMain} />}
                />
                <Route
                  path="/systemInvoiceApproverAssignments"
                  element={<ProtectedRoute element={SystemInvoiceApproverAssignmentsMain} />}
                />
                <Route
                  path="/approvalPersonsInvoiceManagement"
                  element={
                    <ProtectedRoute
                      element={ApprovalPersonsInvoiceManagement}
                      requiredPermission="Approval Persons Invoice Management"
                    />
                  }
                />
                <Route
                  path="/approvalPersonsSystemInvoiceManagement"
                  element={
                    <ProtectedRoute
                      element={ApprovalPersonsSystemInvoiceManagement}
                      requiredPermission="Approval Persons System Invoice Management"
                    />
                  }
                />
                <Route
                  path="/vendorInvoiceManagement"
                  element={
                    <ProtectedRoute
                      element={VendorInvoiceManagement}
                      requiredPermission="Vendor Invoice Management"
                    />
                  }
                />
                <Route
                  path="/systemInvoiceManagementVendor"
                  element={
                    <ProtectedRoute
                      element={SystemVendorInvoiceManagement}
                      requiredPermission="System Invoice Management Vendor"
                    />
                  }
                />
                {/* Use splat so invoiceNumber can contain '/' and other chars */}
                <Route
                  path="/approvalPersonsInvoiceManagement/invoiceDetails/*"
                  element={<ProtectedRoute element={InvoiceApproveRejectForm} />}
                />
                <Route
                  path="/approvalPersonsSystemInvoiceManagement/invoiceDetails/*"
                  element={<ProtectedRoute element={SystemInvoiceApproveRejectForm} />}
                />
                {/* Use splat for vendor invoice details so invoiceNumber can contain \"/\" and other chars */}
                <Route
                  path="/vendorInvoiceManagement/invoiceDetails/*"
                  element={<VendorInvoiceDetails />}
                />
                <Route path="/vendorInvoiceManagement/newInvoice" element={<VendorInvoiceForm />} />

                <Route
                  path="/systemInvoiceManagementVendor/invoiceDetails/*"
                  element={<SystemVendorInvoiceDetails />}
                />
                <Route
                  path="/systemInvoiceManagementVendor/newInvoice"
                  element={<SystemVendorInvoiceForm />}
                />
              </Routes>
            </ThemeProvider>
          </div>
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Router>
      </BackdropProvider>
    </Provider>
  );
}

export default App;
